import React from "react";
import "./LineLoader.css";
const LineLoader = () => {
  return (
    <ul class="wave-menu">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
  );
};

export default LineLoader;
